import React, { FC, useEffect, useState } from "react";
import { FormBaseType, FormBasicsDto, UserRole } from "@green0meter/api-client";
import { isEmpty } from "lodash";

import CollectDataTable from "./components/CollectDataTable";
import CollectDataAction from "./components/CollectDataAction";
import Co2CollectDataSkeleton from "./CollectData.skeleton";

import { useGetAvailableForms } from "@api";
import { useUserStore } from "@store/user";

interface CollectDataProps {
  formBaseType: FormBaseType;
  titleKey: string;
  descriptionKey: string;
  color?: string;
  icon?: string;
  buttonTextKey: string;
  noFormsTextKey: string;
}

const CollectData: FC<CollectDataProps> = ({
  formBaseType,
  titleKey,
  descriptionKey,
  color,
  icon,
  buttonTextKey,
  noFormsTextKey,
}) => {
  const [myForms, setMyForms] = useState<FormBasicsDto[]>([]);
  const { user } = useUserStore();
  const { availableForms, isLoadingAvailableForms, isFetchingAvailableForms } =
    useGetAvailableForms(user, [formBaseType]);

  useEffect(() => {
    setMyForms(availableForms || []);
  }, [availableForms]);

  if (isLoadingAvailableForms) {
    return <Co2CollectDataSkeleton />;
  }

  // TODO: handle Managers view on co2 forms - manager should see only forms containing assinged questions to him/her
  if (
    !isEmpty(myForms) ||
    user?.role === UserRole.Manager ||
    user?.role === UserRole.Respondent ||
    user?.role === UserRole.Auditor
  ) {
    return (
      <CollectDataTable
        forms={myForms}
        formBaseType={formBaseType}
        isFetchingAvailableForms={isFetchingAvailableForms}
      />
    );
  }

  return (
    <CollectDataAction
      titleKey={titleKey}
      descriptionKey={descriptionKey}
      color={color}
      icon={icon}
      buttonTextKey={buttonTextKey}
      noFormsTextKey={noFormsTextKey}
      formBaseType={formBaseType}
    />
  );
};

export default CollectData;
